import React, { useState } from "react";
import { signInWithEmailAndPassword } from "firebase/auth";
import '../css/AccountsLoginPage.css'; // Add custom styles for the login page
import { auth } from "../firebase-config";

const AccountsLoginPage = () => {
    const [email, setEmail] = useState("")
    const [password, setPassword] = useState("")
    const [errors, setErrors] = useState({});
    const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;

    const validateForm = () => {
        const newErrors = {};
        
        if (!email || !emailRegex.test(email)) {
            newErrors.email = !email ? 'Email is required' : 'Invalid email format';
        }

        if (!password || password.length <= 6) {
            newErrors.password = password ? 'Password must be at least 7 characters.' : 'Password is required';
        }

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) return;

        try {
            await signInWithEmailAndPassword(auth, email, password);
            console.log("User logged in Successfully");
            window.location.href="/pages/Homepage"
        } catch (error) {
            console.log(error.message);
            if (error.code === 'auth/invalid-credential') {
                setErrors(prevErrors => ({...prevErrors, password: 'Incorrect password. Please try again.'}));
            } else if (error.code === 'auth/user-not-found') {
                setErrors(prevErrors => ({...prevErrors, email: 'Account not found. Please check your email address.'}));
            } else {
                setErrors(prevErrors => ({...prevErrors, general: error.message}));
            }
        }
    };

    return (
        <div className="login-page">
            <form className="login-form" onSubmit={handleSubmit}>
                <h1>Login</h1>
                <div className="form-group">
                    <label htmlFor="email">Email</label>
                    <input
                        type="text"
                        id="email"
                        name="email"
                        placeholder="Email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        className={`form-control ${errors.email ? 'error-border' : ''}`}
                    />
                    {errors.email && <div className="error-message">{errors.email}</div>}
                </div>
                <div className="form-group">
                    <label htmlFor="password">Password</label>
                    <input
                        type="password"
                        id="password"
                        name="password"
                        placeholder="Password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        className={`form-control ${errors.password ? 'error-border' : ''}`}
                    />
                    {errors.password && <div className="error-message">{errors.password}</div>}
                </div>
                <button type="submit" className="login-btn">Login</button>
            </form>
        </div>
    );
};

export default AccountsLoginPage;